/* eslint-disable-rule jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import Icon from './Icon'

const ViewMore = (props) => {
    const [expanded, setExpanded] = useState(false)
    return (
        <>
            <div style={{ maxHeight: (!expanded && '2.3rem') || undefined, overflow: 'hidden', wordBreak: 'break-word' }}>
                {(expanded && props.children) || null}
            </div>
            {(!expanded && (
                <a href="#" onClick={(e) => e.preventDefault() || setExpanded(true)}>
                    {props.more || 'Read more'} <Icon name="angle-down" />
                </a>
            )) ||
                null}
            {(expanded && (
                <a href="#" onClick={(e) => e.preventDefault() || setExpanded(false)}>
                    {props.less || 'Show less'} <Icon name="angle-up" />
                </a>
            )) ||
                null}
        </>
    )
}

export default ViewMore
